import React from 'react';
import PropTypes from 'prop-types';
import { useSwiper } from 'swiper/react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';

const Float = (props) => {
    const swiper = useSwiper();
    const { slideIndex, config } = props;

    const slides = config.filter(a => a.isShow && a.id.match(/[0-9]/g));

    return (
        <div className={Style.float}>
            {
                config.find(a => a.id === '1').isShow &&
                <div className={slideIndex === '1' ? Style.active : ''} onClick={() => swiper.slideTo(slides.findIndex(a => a.id === '1'))}>君品故事</div>
            }
            {
                config.find(a => a.id === '2').isShow &&
                <div className={slideIndex === '2' ? Style.active : ''} onClick={() => swiper.slideTo(slides.findIndex(a => a.id === '2'))}>君品看点</div>
            }
            {
                config.find(a => a.id === '3').isShow &&
                <div className={slideIndex === '3' ? Style.active : ''} onClick={() => swiper.slideTo(slides.findIndex(a => a.id === '3'))}>君品瞬间</div>
            }
            {
                config.find(a => a.id === '4').isShow &&
                <div className={slideIndex === '4' ? Style.active : ''} onClick={() => swiper.slideTo(slides.findIndex(a => a.id === '4'))}>君品答谢</div>
            }
        </div>
    );
};

Float.propTypes = {
    slideIndex: PropTypes.string,
    config: PropTypes.array
};

export default errorBoundary(Float);
